<template>
    <div :class="(pinState)?'table-row pinned-tab':'table-row'">
        <div class="col booking-node">
            <div :class="{'hidden-div' : !(item.id > 0) || leaveEntry || (descriptionDisabled && actualHoursDisabled && fromToDisabled)}"   class="custom-checkbox">
                <input type="checkbox" :disabled="!(item.id > 0) || leaveEntry || (descriptionDisabled && actualHoursDisabled && fromToDisabled)"  v-model="checkList" :value="item.id"/>
                <label for class="custom-checkbox-label"></label>
            </div>
            <div class="select-wrapper" :class="bookClassObject">
                <v-select
                        :options="bookingData"
                        :disabled=" leaveEntry || item.released"
                        label="bookingNode"
                        :clear-button="false"
                        v-model="booking_node"
                        @input="onSelect"
                >
                <template #option="{ bookingNode }" >
                    <h7 style="font-size: 14px;"  v-tooltip.bottom.light="bookingNode" color="solid">{{ bookingNode }}</h7>
                </template>
            </v-select>
            </div>
        </div>
        <div class="col position">
            <div class="select-wrapper" :class="posClassObject">
                <v-select
                        :options="positionData"
                        :disabled=" leaveEntry || item.released"
                        label="positionTitle"
                        clear-button-icon="false"
                        v-model="position"
                        :resetOnOptionsChange="true"
                ></v-select>
            </div>
        </div>
        <div class="col actual-hours">
            <input type="text" class="ant-time-picker-input" v-model="actualText" maxlength="5" @blur="setActualHours" :disabled="!position || saveFlagValue  || item.released || actualHoursDisabled" 
            :class="actualClassObject">
        </div>
        <div class="col from">
            <input type="text" class="ant-time-picker-input" v-model="fromText" maxlength="5" @blur="setFromTime" :disabled="!position ||saveFlagValue  || item.released || fromToDisabled" 
            :class="[fromClassObject,{'error-border':errors.from}]" >
        </div>
        <div class="col to">
            <input type="text" class="ant-time-picker-input" v-model="toText" maxlength="5" @blur="setToTime" :disabled="!position || saveFlagValue  || item.released || fromToDisabled"  
            :class="[toClassObject,{'error-border':errors.to}]" >
        </div>
        <div class="description col">
            <input type="text" :disabled="!position || saveFlagValue || item.released || descriptionDisabled" class="Description" v-model="item.description" @blur="setDescription"
                   :class="[descClassObject,{'error-border':errors.desc}]"/>
            <div v-if="!item.released && !leaveEntry" class="access-btn">
				<span :class="{'hidden-div-pin' : leaveEntry || isLeaveNode}" v-if="(item.id > 0 || item.pinned)" class="pin-icon" @click.stop.prevent="pinIt">
					<img class="un-pinned" src="../../../assets/images/icons/pin-icon.png" alt/>
					<img class="pinned" src="../../../assets/images/icons/pinned-icon.png" alt/>
				</span>
                <span @click.stop.prevent="deleteEntry" v-if=!item.pinned>
					<img src="../../../assets/images/icons/delete-icon.png" alt/>
				</span>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import 'ant-design-vue/lib/time-picker/style/css';

    export default {
        name: "Times",
        props: ["item", "index", "error","overlapError"],
        data() {
            return {
                time: this.changeTimeFormat(this.item.actualTime),
                fromTime: this.changeTimeFormat(this.item.from),
                toTime: this.changeTimeFormat(this.item.to),
                startOfDay: moment().startOf('day').set('hour', 10),
                errors: {
                    actual_hours: false,
                    from: false,
                    to: false,
                    desc:false
                },
                actualText : null,
                fromText :  null,
                toText :  null,
                isLeaveNode: false
            };
        },
        mounted() {
            this.actualText = (this.item.actualTime != null && this.item.actualTime.length) > 7 ? this.timeConvert(this.item.actualTime) : null,
            this.fromText = (this.item.from != null && this.item.from.length) > 7 ? this.item.from.substr(0, 5) : null,
            this.toText = (this.item.to != null && this.item.to.length) > 7 ? this.item.to.substr(0, 5) : null
        },
        computed: {
            actualTextValue: function () {
                return (this.item.actualTime != null && this.item.actualTime.length) > 7 ? this.timeConvert(this.item.actualTime) : null;
            },
            fromTextValue: function () {
                return (this.item.from != null && this.item.from.length) > 7 ? this.item.from.substr(0, 5) : null;
            },
            toTextValue: function () {
                return (this.item.to != null && this.item.to.length) > 7 ? this.item.to.substr(0, 5) : null;
            },
            timePlaceholder: function () {
                return 'HH:mm';
            },
            saveFlagValue:function(){
                return this.$store.state.qtime.saveFlag;
            },
            /**
             * Get all rows from store
             */
            timeData: function () {
                return this.$store.state.qtime.timeEntries;
            },
            bookingData: function () {
                return this.$store.state.qtime.bookingNodes;
            },
            positionData: function () {
                if (this.booking_node) {
                    return this.$store.state.qtime.positions.filter(x => x.bookingNode === this.booking_node.itemId);
                } else {
                    return this.$store.state.qtime.positions.filter(x => x.bookingNode === 0);
                }
            },
            booking_node: {
                get: function () {
                    return this.bookingData.find(x => x.itemId === this.item.bookingId);
                },
                set: function (value) {
                    this.$store.commit("setBookingNodeId", {id: this.index, value: value});

                    if (this.item.positionId){
                        this.$store.commit("setPositionId", {id: this.index, value: { itemId: null } });
                    }
                }
            },
            position: {
                get: function () {
                    return this.positionData.find(x => x.itemId === this.item.positionId);
                },
                set: function (value) {
                    this.$store.commit("setPositionId", {id: this.index, value: value});
                }
            },
            checkList: {
                get: function () {
                    return this.$store.state.qtime.selectedRows;
                },
                set: function (value) {
                    this.$store.commit("setSelectedRows", value);
                }
            },
            pinState: function () {
                return this.item.pinned == true;
            },
            bookClassObject: function () {
                return {'error-border': this.error && this.booking_node == null}
            },
            posClassObject: function () {
                return {'error-border': this.error && this.position == null}
            },
            descClassObject: function () {
                return {
                    'pinned-error-border': (this.error && this.pinState && this.position && this.position.description === "Mandatory") && this.item.description == null && (this.item.actualTime!=null || this.item.from!=null || this.item.to!=null),
                    'error-border': this.error && !this.pinState && this.position && this.position.description === "Mandatory" && this.item.description == null
                    }
            },
            actualClassObject: function () 
            {
                
                    return {
                        'pinned-error-border': (this.error && this.pinState && this.position && this.position.actualHours === "Mandatory") && this.item.actualTime == null && (this.item.actualTime!=null || this.item.from!=null || this.item.to!=null),
                        'error-border': this.error && !this.pinState && this.position && this.position.actualHours === "Mandatory" && this.item.actualTime == null
                    }
                
                    //return {'error-border': this.error && this.position && this.position.actualHours === "Mandatory" && this.item.actualTime == null}
                
            },
            fromClassObject: function () {
                return {
                    'pinned-error-border': (this.error && this.pinState && this.position && this.position.fromTo === "Mandatory") && this.item.from == null && (this.item.actualTime!=null || this.item.from!=null || this.item.to!=null),
                    'error-border': this.error && !this.pinState && this.position && this.position.fromTo === "Mandatory" && this.item.from == null
                    }
            },
            toClassObject: function () {
                return {
                    'pinned-error-border': (this.error && this.pinState && this.position && this.position.fromTo === "Mandatory") && this.item.to == null && (this.item.actualTime!=null || this.item.from!=null || this.item.to!=null),
                    'error-border': this.error && !this.pinState && this.position && this.position.fromTo === "Mandatory" && this.item.to == null
                    }
            },
            descriptionDisabled: function () {
                return  (this.position && this.position.description === "Locked") || this.leaveEntry;
            },
            actualHoursDisabled: function () {
                return (this.position && this.position.actualHours === "Locked") || this.leaveEntry;
            },
            fromToDisabled: function () {
                return  (this.position && this.position.fromTo === "Locked") || this.leaveEntry;
            },
            released: function () {
                return this.$store.state.qtime.released;
            },
            leaveEntry: function () {
                return this.item.podioRequestId > 0;
            }
        },
        methods: {
            onSelect(value) {
                 if (value !== undefined && (value.bookingNode.startsWith('Sickness') || value.bookingNode.startsWith('Vacation'))) {
                   this.isLeaveNode = true;
                } else {
                    this.isLeaveNode = false;
                }
            },
            changeTimeFormat(time) {
                return time ? moment(time, 'HH:mm:ss') : null
            },
            pinIt: function () {
                if (this.item.id) {
                    let pinned = this.item.pinned == true;

                    this.$store.dispatch("pinUnpin", {'id': this.item.id, 'pinState': !pinned}).then(
                        () => {
                            this.$store.commit("pinUnpinEntry", this.index);
                        })
                } else if (this.item.parentPinnedId) {
                    this.$store.dispatch("pinUnpin", {'id': this.item.parentPinnedId, 'pinState': false}).then(
                        () => {
                            this.$store.commit("pinUnpinEntry", this.index);
                            this.deleteEntry();
                        })
                } else {
                    //console.log("Todo: pin / unpin without id & parent");
                    this.$store.commit("pinUnpinEntry", this.index);
                }
            },
            deleteEntry: function () {
                if (this.item.id) {
                    this.$emit('clicked', this.item.id, this.index);
                } else {
                    this.$store.commit("removeTimeEntry", this.index);
                }
                this.$store.dispatch('updateHideAnotherLine', false);
            },
            formatedTime(e) {
                this.time = e;

                if (e) {
                    this.item.actualTime = e.format("HH:mm") + ":00";
                    this.item.totalTime = e.format("HH:mm") + ":00";
                } else {
                    this.clearedTime();
                }
            },
            formatedFromTime(e) {
                this.fromTime = e;

                if (e) {
                    if (this.toTime && e > this.toTime) {
                        this.fromTime = null;
                    } else {
                        this.item.from = e.format("HH:mm") + ":00";

                        if (this.item.to) {
                            this.item.totalTime = this.timeDiff(e.format("HH:mm") + ":00", this.item.to);
                            this.item.actualTime = this.item.totalTime;
                            this.time = moment(this.item.totalTime, 'HH:mm:ss');
                        }
                    }
                } else {
                    this.clearedFromTime();
                }
            },
            formatedToTime(e) {
                this.toTime = e;

                if (e) {
                    if (this.fromTime && e < this.fromTime) {
                        this.toTime = null;
                    } else {
                        this.item.to = e.format("HH:mm") + ":00";

                        if (this.item.from) {
                            this.item.totalTime = this.timeDiff(this.item.from, e.format("HH:mm") + ":00");
                            this.item.actualTime = this.item.totalTime;
                            this.time = moment(this.item.totalTime, 'HH:mm:ss');
                        }
                    }
                } else {
                    this.clearedToTime();
                }
            },
            timeDiff(fromStr, toStr) {
                let timeToAddArr = fromStr.split(":");
                let ms = (60 * 60 * parseInt(timeToAddArr[0]) + 60 * (parseInt(timeToAddArr[1]))) * 1000;
                let dateFormat = '1970-01-01T' + toStr;
                let newTime = new Date(dateFormat.replace(/-/g, '/').replace('T', ' ')).getTime() - ms;
                let finalTime = new Date(newTime).toTimeString().substring(0, 8);
                return finalTime;
            },
            formatTimeToDate(dStr) {
                let now = new Date();
                now.setHours(dStr.substr(0, 2));
                now.setMinutes(dStr.substr(3, 2));
                now.setSeconds(0);
                return now;
            },
            clearedTime() {
                this.time = null;
                this.item.actualTime = null;
                this.actualText = null;

                if (this.item.from && this.item.to) {
                    this.item.totalTime = this.timeDiff(this.item.from, this.item.to);
                } else {
                    this.item.totalTime = "00:00:00";
                }
            },
            clearedFromTime() {
                this.fromTime = null;
                this.item.from = null;
                this.fromText = null;

                if (!this.item.actualTime) this.item.totalTime = "00:00:00";
            },
            clearedToTime() {
                this.toTime = null;
                this.item.to = null;
                this.toText = null;

                if (!this.item.actualTime) this.item.totalTime = "00:00:00";
            },
            /**
             * Callback on remove focus
             * @param e - get current event and value from the target
             */
            setActualHours(e) {
                let value = e.target.value;
                value = this.getHoursFromValue(value);
                let decValue = parseFloat(value.replace(",","."));
                let momentTimeActual = moment(new Date(2020, 4, 2, 0, 0, decValue * 3600));
                this.errors.actual_hours = false;

                if (momentTimeActual.isValid()&&value!=="") {
                    this.time = value ? momentTimeActual : null;
                    let actualText = value ? this.setActualTextNoTime(value).toFixed(2).toString().replace(".", ",") : null;
                    this.actualText = actualText;
                    this.item.actualTime = value ? momentTimeActual.format("HH:mm:ss") : null;
                    this.item.totalTime = value ? momentTimeActual.format("HH:mm:ss") : null;
                    this.$emit('timeChanged');
                    this.$emit('timeValueChanged');
                } else {
                    this.errors.actual_hours = true;
                    this.clearedTime();
                }
                if (!this.actualText) {
                    this.$emit('emptyInput');
                }
            },
             hourFromMins: function (num) {
                let hours = (num * 100 / 60);
                return hours > 0 ? hours.toString().replace(".","") : '00';
            },
             timeConvert: function (value) {
                
                 let splitValue = value.split(":");
                 let firstVal = parseFloat(splitValue[0]);
                 let hours = parseFloat(splitValue[1]/60) + parseFloat(splitValue[2]/3600);
                 let actualValue = firstVal+hours;
               
                 return actualValue.toFixed(2).toString().replace(".",",");
            },
            setFromTime(e) {
               
                let value = e.target.value;
                value = this.getHoursFromValue(value);
                this.errors.from = false;
                let momentTime = moment(value, 'HH:mm:ss');
                if (momentTime.isValid()&&value!=="") {
                    this.fromTime = value ? momentTime : null;
                    this.fromText = value ? momentTime.format("HH:mm") : null;
                    this.item.from = value ? momentTime.format("HH:mm") + ":00" : null;

                    if (this.toTime && momentTime > this.toTime) {
                        this.fromTime = null;
                    } else {

                        if (this.item.to) {
                            let timeDiffText = this.timeDiff(momentTime.format("HH:mm") + ":00", this.item.to);
                            this.item.totalTime = timeDiffText;
                            this.item.actualTime = timeDiffText;
                            this.time = moment(this.item.totalTime, 'HH:mm:ss');
                            //this.actualText = timeDiffText.substr(0, 3).replace(":", ",") + this.hourFromMins(timeDiffText.substr(3, 2)).substr(0,2);
                            this.actualText = this.timeConvert(timeDiffText);
                            this.$emit('timeChanged');
                             this.$emit('timeValueChanged');
                        }
                    }
                } else {
                    this.errors.from = true;
                    this.clearedFromTime();
                }
            },
            setToTime(e) {
                let value = e.target.value;
                value = this.getHoursFromValue(value);
                this.errors.to = false;
                let momentTime = moment(value, 'HH:mm:ss');
                if (momentTime.isValid()&&value!=="") {
                    this.toTime = value ? momentTime : null;
                    this.toText = value ? momentTime.format("HH:mm") : null;
                    this.item.to = value ? momentTime.format("HH:mm") + ":00" : null;

                    if (this.fromTime && momentTime < this.fromTime) {
                        this.toTime = null;
                    } else {

                        if (this.item.from) {
                            let timeDiffText = this.timeDiff(this.item.from, momentTime.format("HH:mm") + ":00");
                            this.item.totalTime = timeDiffText;
                            this.item.actualTime = timeDiffText;
                            this.time = moment(this.item.totalTime, 'HH:mm:ss');
                            //this.actualText = timeDiffText.substr(0, 3).replace(":", ",") + this.hourFromMins(timeDiffText.substr(3, 2)).substr(0,2);
                            this.actualText = this.timeConvert(timeDiffText);                            
                            this.$emit('timeChanged');
                           this.$emit('timeValueChanged');
                        }
                    }
                } else {
                    this.errors.to = true;
                    this.clearedToTime();
                }
            },

            getHoursFromValue: function (value) {
                if (/^(\d{3})$/.test(value)) {
                    value = [...value.slice(0, 1), ':', ...value.slice(1)].join('');
                } else if (/^(\d{4})$/.test(value)) {
                    value = [...value.slice(0, 2), ':', ...value.slice(2)].join('');
                }
                return value;
            } ,
            /*Need to replace
            setActualTextValue: function (value) {
                if (/^(\d{3})$/.test(value)) {
                    value = [...value.slice(0, 1), ':', ...value.slice(1)].join('');
                } else if (/^(\d{4})$/.test(value)) {
                    value = [...value.slice(0, 2), ':', ...value.slice(2)].join('');
                }
                let momentTime = moment(value, 'HH:mm:ss');
                if (momentTime.isValid() || !value) {
                    this.time = value ? momentTime : null;
                    let actualText = value ? momentTime.format("H:mm") : null;
                    return actualText.replace(":", ",")
                }
                else{
                    return null;
                }
            },*/
            setActualTextNoTime: function (value) {
                if (/^(\d{3})$/.test(value)) {
                    value = [...value.slice(0, 1), ':', ...value.slice(1)].join('');
                } else if (/^(\d{4})$/.test(value)) {
                    value = [...value.slice(0, 2), ':', ...value.slice(2)].join('');
                }
                
                    return parseFloat(value.replace(",", "."));
                
            },
            setDescription:function(e){
                this.$emit('descriptionChanged');
                this.errors.desc = false
               if(e.target.value == "" && this.position.description === "Mandatory"){
                   this.errors.desc = true;
               }
             
            } 
        },
        watch: {
            item: function (value) {
                if (value.pinned && value.id===0) {
                    this.actualText = null;
                    this.fromText = null;
                    this.toText = null;
                }
            }
        }
    };
</script>

<style scoped>
    .error-border {
        border: 1px solid red!important;
    }

    .pinned-error-border {
        border: 1px solid red!important;
    }
    .date-overlap-error {
         border: 1px solid red!important;
    }
    .hidden-div {
        opacity: 0;
    }

    span.error-border {
        border: 1px solid red;
        border-radius: 4px;
    }
    .hidden-div-pin {
        display:none;
    }
</style>
